import React, { useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';

import ToMainMenuButton from '@ts-core/components/ToMainMenuButton';

import { useCourse } from 'modules/courses/hooks';
import CourseMediaStatsTable from 'modules/courses/components/CourseMediaStatsTable';

import { useCourseMediaStats } from '../../hooks/stats';

const CourseMediaStatsPage = () => {
  const intl = useIntl();
  const history = useHistory();
  const { courseId } = useParams();

  const onClickMediaItem = useCallback(
    (mediaItem) => {
      history.push(`/${courseId}/media-stats/${mediaItem.subject._id}/${mediaItem._id}`);
    },
    [history, courseId]
  );

  const { course } = useCourse({ courseId });
  const { mediaStats, loading, error, onFilterStats, onFetchStats, onGetXlsxData } = useCourseMediaStats({ courseId });

  return (
    <Box>
      <ToMainMenuButton title={intl.formatMessage({ id: 'courseMediaStatsTable.title' })} />
      <CourseMediaStatsTable
        course={course}
        mediaStats={mediaStats}
        loading={loading}
        error={error}
        onFetchStats={onFetchStats}
        onFilterStats={onFilterStats}
        onClickMediaItem={onClickMediaItem}
        onGetXlsxData={onGetXlsxData}
      />
    </Box>
  );
};

CourseMediaStatsPage.propTypes = {};

export default CourseMediaStatsPage;
